import cx from "classnames";
import React from "react";

export const Alert = ({alert, children, className = null}) => <div className={cx("rounded p-5 mt-10 border", className, {
    "bg-green-100  border-green-300": alert == 'success',
    "bg-rose-100  border-rose-300": alert == 'danger',
    "bg-orange-100  border-orange-300": alert == 'warning',
    "bg-blue-100  border-blue-300": alert == 'info',
    })}>
    {children}
</div>